import API from '../index'
import { FreeTrialEligibility } from './entities'
import { prop } from 'ramda';

const getFreeTrialEligibility = externalAccountId =>
  API.Subscription.getFreeTrialEligibility({externalAccountId})
    .then(prop('data'))
    .then(FreeTrialEligibility)

export { getFreeTrialEligibility }
